import React from 'react'

/**
 * ErrorBoundary — catches unhandled JS errors anywhere in the React tree
 * and shows a clean fallback UI instead of a white crash screen.
 * HIPAA note: never renders the raw error message to the user (could leak PHI
 * from state objects). The error is logged to the console for developer use.
 */
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError() {
    return { hasError: true }
  }

  componentDidCatch(error, info) {
    // Log to console only — Sentry will pick this up via its global handler
    console.error('[ErrorBoundary] Unhandled error:', error, info?.componentStack)
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '60vh',
          fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
          color: '#1e293b',
          padding: '40px 24px',
          textAlign: 'center',
        }}>
          <div style={{ fontSize: 48, marginBottom: 16 }}></div>
          <h2 style={{ fontSize: 22, fontWeight: 700, margin: '0 0 10px' }}>
            Something went wrong
          </h2>
          <p style={{ fontSize: 15, color: '#64748b', maxWidth: 400, margin: '0 0 28px', lineHeight: 1.6 }}>
            An unexpected error occurred. Please refresh the page to try again.
            If the problem persists, contact support.
          </p>
          <button
            onClick={() => window.location.reload()}
            style={{
              padding: '12px 28px',
              background: '#0d9488',
              color: '#fff',
              border: 'none',
              borderRadius: 8,
              fontSize: 15,
              fontWeight: 600,
              cursor: 'pointer',
            }}
          >
            Refresh Page
          </button>
        </div>
      )
    }

    return this.props.children
  }
}

export default ErrorBoundary
